module.exports = __webpack_public_path__ + "img/hpgs-logo.a9bfd5dc.png";